import React, { Component } from "react";
import { Card, Image, Icon, Button } from "semantic-ui-react";

class ProfilCard extends Component {
  render() {
    return (
      <div>
        <Card link>
          <Card.Content>
            <Image
              floated="right"
	            height="100px"
              src={this.props.picture}
              rounded
            />
            <Card.Header>
              {this.props.name}
            </Card.Header>
            <Card.Meta>{this.props.campus}</Card.Meta>
            <Card.Meta>{this.props.office}</Card.Meta>            
            <Card.Meta>{this.props.title}</Card.Meta>
          </Card.Content>
          <Card.Content extra>
            {this.props.mail &&
            <React.Fragment>
              <a class="custom-profil-card-text" href={"mailto:" + this.props.mail}>
                <Icon name="mail" />
                {this.props.mail}
              </a>
              <br />
            </React.Fragment>
            }
            {this.props.telPro &&
            <React.Fragment>
              <a class="custom-profil-card-text" href={"tel:" + this.props.telPro}>
                <Icon name="phone" />
                {this.props.telPro}
              </a>
              <br />
            </React.Fragment>
            }
            {this.props.mobilePro && 
            <a class="custom-profil-card-text" href={"tel:" + this.props.mobilePro}>
              <Icon name="phone" />
              {this.props.mobilePro}
            </a>
            }
            <Button
              fluid
              content="Voir le profil"
              onClick={this.props.onClick}
            />
          </Card.Content>
        </Card>
      </div>
    );
  }
}

export default ProfilCard;



// WEBPACK FOOTER //
// ./src/components/ProfilCard/index.js